// extracted by mini-css-extract-plugin
module.exports = {"bankAccountReport":"styles_bankAccountReport__1m2gH"};